import { FC } from "react";
import { Link } from "react-router-dom";
import { MenuProps } from "@dirootie-web/elements-types";
import { IconTalTech } from "../../icons";

export interface IHamburgerMenuNavigation {
  menuState: boolean;
  closeFn: (x: boolean) => void;
}

export const MenuToggle: FC<MenuProps> = ({items=[],toggle}: MenuProps) => {
  return (
    <>
      <div
        onClick={() => toggle()}
        className={"ebd-navigation-close"}
      >
        <IconTalTech kind="close"/>
      </div>
      <div className={"ebd-hamburger-menu"}>
        {items.map((el, index) => (
          <div
            onClick={() => toggle()}
            key={el.to}
            className={"my-3"}
          >
            <Link to={el.to}>
              <h2 className={"ebd-hamburger-element"}>{el.label}</h2>
            </Link>
          </div>
        ))}
      </div>
    </>
  );
};
